export function parsePhysicalIO(value) {
    if (value == -1) {
        return { block_id: null, input_number: null };
    }
    const raw_block_id = (value >> 4) & 0xffff;
    return {
        block_id: raw_block_id == 0 ? null : raw_block_id,
        input_number: (value & 0x0f) | ((value >> 16) & 0xf0),
    };
}
export function composePhysicalIO(block_id, input_number) {
    if (input_number == null) {
        return -1;
    }
    return (((block_id == null ? 0 : block_id) << 4) |
        (input_number & 0x0f) |
        ((input_number & 0xf0) << 16));
}
